export default "__VITE_ASSET__BWuXIlML__"